import { isTestEnvironment } from "./utils/app";

const ETA_HOSTS = new Set(["etainfo.com", "www.etainfo.com", "eta.page", "www.eta.page"]);
const ETA_TOKEN_PATH_PATTERN = /^\/[A-HJ-KM-NP-Z2-9]{4}-[A-HJ-KM-NP-Z2-9]{4}-[A-HJ-KM-NP-Z2-9]{4}\/?$/i;

export function shouldUseEtaApp(hostname?: string, pathname?: string) {
    const host = hostname ?? (typeof window !== "undefined" ? window.location.hostname : "");
    const path = pathname ?? (typeof window !== "undefined" ? window.location.pathname : "");
    if (ETA_HOSTS.has(host)) {
        return true;
    }
    return isTestEnvironment() && isEtaTokenPath(path);
}

export function isEtaTokenPath(pathname: string) {
    return ETA_TOKEN_PATH_PATTERN.test(pathname);
}
